import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  ApiClientService,
  ApiResponse
} from '../../shared/services/api-client.service';
import { AB_API_TRANSFERS_TO_ACCOUNTS } from '../../shared/constants';
import { Observable } from 'rxjs';

enum ToAccountsListItemType {
  OwnAccount,
  BeneficiaryAddressDetails,
  BillPayee
}

interface IBaseAccount {
  name: string;
  alias: string;
  description: string;
  accountNumber: string;
  listItemType: string;
}

interface IBankAccountListItem extends IBaseAccount {
  text: string;
  value: string;
  bankAccountType: string;
  portfolioName: string;
  selected: boolean;
  type: string;
}

interface IBasicAddress extends IBaseAccount {
  id: string;
  pn: string;
  accountId: string;
  iban: string;
  bicCode: string;
  aba: string;
  bank: string;
  intermediaryAba: string;
  intermediaryBic: string;
  intermediaryBank: string;
  intermediaryBankAccount: string;
  domesticIndicator: string;
  country: string;
  city: string;
  streetName: string;
  number: string;
}

interface IBillPayees extends IBaseAccount {
  id: string;
  accountId: string;
  iban: string;
  bicCode: string;
  bank: string;
  domesticIndicator: string;
  attributes?: any;
}

interface ToAccountsListForTransfersResponse extends ApiResponse {
  ownBankAccounts?: IBankAccountListItem[];
  beneficiariesAddresses?: IBasicAddress[];
  billPayeesCompanies?: IBillPayees[];
}

@Injectable({
  providedIn: 'root'
})
export class ToAccountsService extends ApiClientService {
  constructor(http: HttpClient) {
    super(http, AB_API_TRANSFERS_TO_ACCOUNTS);
  }

  getToAccountsList(): Observable<ToAccountsListForTransfersResponse> {
    return this.get();
  }
}

export {
  IBillPayees,
  IBaseAccount,
  IBasicAddress,
  IBankAccountListItem,
  ToAccountsListItemType,
  ToAccountsListForTransfersResponse
};
